import { render } from "./HomeBanner.vue?vue&type=template&id=098470ca&scoped=true"
const script = {}

import "./HomeBanner.vue?vue&type=style&index=0&id=098470ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098470ca"]])

export default __exports__